import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function TransporteAnexo21y22RMF2026SistemasDeMedicion() {
  return (
    <CategoryPage
      category="transporteAnexo21Y22Rmf2026SistemasDeMedicion2026"
      pageTitle="Sistemas De Medicion 2026"
    />
  );
}

export default TransporteAnexo21y22RMF2026SistemasDeMedicion;
